import { Compass, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SAMPLE_GAME } from '@/lib/sample';

type WelcomeOfferProps = {
  /** The account has no data of its own: the tour runs on sample data. */
  onSample: boolean;
  onStart: () => void;
  /** "Not now" or ×: the offer is answered and does not come back. */
  onDecline: () => void;
};

/**
 * The once-per-person offer of the tour: a small card in the corner, never a
 * modal, so it can be ignored. Answering it either way is remembered.
 */
export function WelcomeOffer({ onSample, onStart, onDecline }: WelcomeOfferProps) {
  return (
    <section
      aria-labelledby="tour-offer-title"
      className="fixed right-4 bottom-4 z-45 w-[min(340px,calc(100vw-32px))] rounded-pop bg-surface p-4 text-fg shadow-pop motion-safe:animate-pop-in"
    >
      <div className="flex items-start gap-3">
        <span aria-hidden="true" className="grid size-8 shrink-0 place-items-center rounded-ctl bg-accent-wash text-accent-ink">
          <Compass className="size-4" />
        </span>
        <div className="min-w-0 flex-1">
          <h2 id="tour-offer-title" className="m-0 text-base font-semibold">
            New here? Take the tour
          </h2>
          <p className="mt-1 mb-0 text-sm text-muted">
            {onSample
              ? `Two minutes through every screen, on sample data from ${SAMPLE_GAME}, a fictional game.`
              : 'Two minutes through every screen and what each one tells you.'}
          </p>
        </div>
        <Button size="icon-sm" variant="ghost" aria-label="Dismiss the tour offer" className="-mt-1 -mr-1.5" onClick={onDecline}>
          <X className="size-4" aria-hidden="true" />
        </Button>
      </div>
      <div className="mt-3.5 flex justify-end gap-2">
        <Button size="sm" variant="ghost" onClick={onDecline}>
          Not now
        </Button>
        <Button size="sm" variant="primary" onClick={onStart}>
          Start the tour
        </Button>
      </div>
    </section>
  );
}
